/** Die Arbeitsfläche selbst: Frames, Text, eingebettete Seiten, Zoom, Vortrag. */
export const canvas = {
    'canvas.dropHint': 'Datei hier ablegen',
    // --- Zoom ------------------------------------------------------------------
    'zoom.in': 'Hineinzoomen',
    'zoom.out': 'Herauszoomen',
    'zoom.reset': 'Auf 100 % zurücksetzen',
    'zoom.fit': 'Einpassen',
    'zoom.fitTitle': 'Alles einpassen (Taste 0)',
    // --- Frames ----------------------------------------------------------------
    'frame.fill': 'Fläche',
    'frame.fillColor': 'Füllfarbe',
    'frame.border': 'Rahmen',
    'frame.borderWidth': 'Rahmenstärke',
    'frame.borderColor': 'Rahmenfarbe',
    'frame.without': 'ohne',
    'frame.grid': 'Raster',
    'frame.gridTitle': 'Woran Medien in diesem Frame einrasten',
    'frame.paddingTitle': 'Innenrand (Satzspiegel), an dem Inhalte einrasten',
    'frame.paddingAuto': 'Rand automatisch ({percent} %)',
    'frame.paddingNone': 'Rand ohne',
    'frame.paddingShare': 'Rand {percent} %',
    'frame.auto': 'automatisch ({value})',
    'frame.columnsTitle': 'Spalten innerhalb des Satzspiegels',
    'frame.columns': '{count} Spalten',
    'frame.noColumns': 'ohne Spalten',
    'frame.rowsTitle': 'Zeilen innerhalb des Satzspiegels',
    'frame.rows': '{count} Zeilen',
    'frame.noRows': 'ohne Zeilen',
    'frame.scaleContent': 'Inhalt mit',
    'frame.scaleOnTitle': 'Größenändern nimmt den Inhalt mit — das Seitenverhältnis des Frames rastet dabei ein. Klicken für freies Ziehen.',
    'frame.scaleOffTitle': 'Größenändern verändert nur den Rahmen. Klicken, damit der Inhalt mitwächst.',
    'frame.saveTemplate': 'Als Vorlage',
    'frame.saveTemplateTitle': 'Diesen Frame samt Inhalt als Vorlage sichern',
    'frame.dragTitle': 'Ziehen zum Verschieben',
    'frame.labelTitle': 'Ziehen zum Verschieben · Doppelklick zoomt auf diesen Frame',
    // --- Text ------------------------------------------------------------------
    'text.placeholder': 'Text eingeben …',
    'text.size': 'Schriftgröße',
    'text.sizeSmaller': 'Kleiner',
    'text.sizeLarger': 'Größer',
    'text.font': 'Schrift',
    'text.fontBoard': 'Schriften des Boards',
    'text.fontHeading': 'Überschrift',
    'text.fontBody': 'Fließtext',
    'text.lineHeight': 'Zeilenabstand',
    'text.lineHeightTitle': 'Zeilenabstand — Vielfaches der Schriftgröße',
    'text.scaleFontOnTitle': 'Ziehen an einer Ecke skaliert die Schrift mit. Klicken, damit nur das Feld wächst.',
    'text.scaleFontOffTitle': 'Ziehen an einer Ecke ändert nur das Feld. Klicken, damit die Schrift mitwächst.',
    'text.scaleFont': 'Schrift mit',
    'text.bold': 'Fett',
    'text.italic': 'Kursiv',
    'text.underline': 'Unterstrichen',
    'text.list': 'Aufzählung',
    'text.color': 'Textfarbe',
    'text.align.left': 'Linksbündig',
    'text.align.center': 'Zentriert',
    'text.align.right': 'Rechtsbündig',
    'text.heightAutoTitle': 'Höhe wächst mit dem Text — klicken für feste Höhe',
    'text.heightFixedTitle': 'Feste Höhe — klicken, damit sie wieder mitwächst',
    'text.valign.top': 'Oben im Feld',
    'text.valign.middle': 'Mittig im Feld',
    'text.valign.bottom': 'Unten im Feld',
    // --- Eingebettete Seiten ---------------------------------------------------
    'iframe.width': 'Breite',
    'iframe.custom': 'Eigene',
    'iframe.height': 'Höhe',
    'iframe.heightTitle': 'Wie viel der Seite scrollbar bereitsteht',
    'iframe.windows': '{factor}× Fenster',
    'iframe.clickInside': 'In der Seite klicken',
    'iframe.shieldTitle': 'Scrollen bewegt die Seite für alle · Doppelklick, um darin zu klicken',
    'iframe.release': 'Steuerung beenden · Esc',
    'iframe.blocked': 'Diese Seite erlaubt keine Einbettung.',
    'iframe.openTab': 'In neuem Tab öffnen',
    // --- Vortrag ---------------------------------------------------------------
    'present.previous': 'Vorheriger Frame',
    'present.next': 'Nächster Frame',
    'present.noFrames': 'Noch keine Frames angelegt',
    'present.free': 'Frei',
    'present.fixed': 'Fest',
    'present.lockTitle': 'Ansicht wieder festsetzen — dann bewegt nur der Framewechsel das Bild',
    'present.unlockTitle': 'Freies Bewegen erlauben — Zoomen und Ziehen wirkt dann auch bei den Gästen',
    'present.pointer': 'Zeiger',
    'present.pointerOnTitle': 'Zeiger einblenden (Z) — dein Mauszeiger wird für alle zum Leuchtpunkt',
    'present.pointerOffTitle': 'Zeiger ausblenden (Z) — dann wird deine Zeigerposition nicht mehr übertragen',
    'present.pointerColorTitle': 'Zeiger in dieser Farbe',
    'present.pointerColorLabel': 'Zeigerfarbe {color}',
    'present.followersTitle': 'Zahl der Teilnehmenden, die deiner Ansicht folgen',
    'present.nobodyConnected': 'Niemand verbunden',
    'present.following': '{followers} von {viewers} folgen',
    'present.stop': 'Beenden',
    'present.someone': 'Jemand',
    'present.isPresenting': '{name} präsentiert',
    'present.lookingAround': 'Du siehst dich gerade frei um',
    'present.followAgain': 'Ansicht wieder folgen',
    // --- Sprechernotizen -------------------------------------------------------
    'notes.title': 'Notizen',
    'notes.clockTitle': 'Seit dem Beginn des Vortrags',
    'notes.empty': 'Für diesen Frame ist nichts hinterlegt. Notizen schreibst du vor dem Vortrag in der Frame-Liste.',
    'notes.next': 'Als Nächstes',
    'notes.last': 'Letzter Frame',
    // --- Gast-Vorschau ---------------------------------------------------------
    'preview.title': 'Gast-Vorschau',
    'preview.empty': 'Noch niemand über den Gast-Link verbunden.',
    'preview.previous': 'Vorheriger Gast',
    'preview.next': 'Nächster Gast',
    // --- Wartebildschirm -------------------------------------------------------
    'waiting.notStarted': 'Die Präsentation hat noch nicht begonnen. Diese Seite wechselt von selbst, sobald es losgeht — du musst nichts tun.',
    'waiting.changesItself': 'Diese Seite wechselt von selbst, sobald es losgeht — du musst nichts tun.',
    'waiting.lockedNote': 'In dieser Freigabe folgt deine Ansicht durchgehend der des Vortragenden.',
    'waiting.byDigitalwart': 'von Digitalwart',
    // --- Dateien ---------------------------------------------------------------
    'upload.allowed': 'Bilder (JPEG, PNG, WebP, AVIF, GIF, TIFF, SVG), Videos (MP4, WebM, MOV) und PDF',
    'upload.heic': '„{name}": HEIC-Bilder vom iPhone werden nicht unterstützt. In den iPhone-Einstellungen unter „Kamera → Formate" auf „Maximale Kompatibilität" umstellen oder das Bild als JPEG exportieren.',
    'upload.unsupported': '„{name}" ist kein Dateityp, den Præsto ablegen kann. Möglich sind {allowed}.',
    'upload.tooLarge': '„{name}" ist zu groß ({size}, erlaubt sind {limit}).',
};
//# sourceMappingURL=canvas.js.map